import * as Yup from "yup"
import { transformSnakeToCamel } from "utils/transform"

import { ERROR_MESSAGES } from "constants/validation"

/**
 * URL Link Schema
 * Represents a tracking link created by an affiliate
 * Base schema is loose to allow loading legacy data.
 */
export const UrlLinkSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    affiliateId: Yup.number().nullable(),
    urlId: Yup.number().nullable(),
    productsId: Yup.number().nullable(),
    urlParameterAffiliate: Yup.string().nullable(),
    urlParameterCampaign: Yup.string().nullable(),
    urlParameterProduct: Yup.string().nullable(),
    generatedUrl: Yup.string().nullable(),
    qrCode: Yup.string().nullable(),
    totalClicks: Yup.number().nullable(),
    uniqueClicks: Yup.number().nullable(),
    conversionsCount: Yup.number().nullable(),
    uniqueConversionCount: Yup.number().nullable(),
    creationDatetime: Yup.date().nullable(),
  })

/**
 * URL Link Validation Schema
 * Strict rules applied only during form submission.
 */
export const UrlLinkValidationSchema = UrlLinkSchema.clone().shape({
  urlId: Yup.number().required(ERROR_MESSAGES.REQUIRED),
  urlParameterAffiliate: Yup.string().required(ERROR_MESSAGES.REQUIRED),
  urlParameterCampaign: Yup.string().required(ERROR_MESSAGES.REQUIRED),
  urlParameterProduct: Yup.string().required(ERROR_MESSAGES.REQUIRED),
  generatedUrl: Yup.string().required(ERROR_MESSAGES.REQUIRED),
  qrCode: Yup.string().required(ERROR_MESSAGES.REQUIRED),
  creationDatetime: Yup.date().required(ERROR_MESSAGES.REQUIRED),
})
